import Http from "../../../network/Http";
const ENDPOINTS = {
  onBoarding: "/onboarding/update",
};

export const postOnBoardingDetails = async (payload) => {
  try {
    const response = await Http.patch(ENDPOINTS.onBoarding, payload);
    return response;
  } catch (e) {
    console.log(e);
  }
};
